<template>
	<div id="loginPanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="login_panel">
                <div class="panel_left">
                    <div class="panel_logo"><img class="logo_icon" src="./img/login_logo.png" alt=""></div>
                    <div class="ad_item"><img class="ad_icon" src="./img/right.png" alt="">每天有超过<span class="yellow_count">10000+</span>人在懒人办公进行文章创作</div>
                    <div class="ad_item"><img class="ad_icon" src="./img/right.png" alt="">每天有<span class="yellow_count">50000+</span>篇原创文章在这里产生</div>
                    <div class="ad_item"><img class="ad_icon" src="./img/right.png" alt="">已经为<span class="yellow_count">2000000+</span>人创作了超过<span class="yellow_count">100000000+</span>次写作</div>
                </div>
                <div class="panel_right">
                    <div class="panel_close" @click="closePanel"></div>
                    <div class="panel_body">
                        <div class="panel_title">
                            <span class="title_text"><img class="wx_icon" src="./img/weixin.png" />微信扫码注册或登录<img class="free_icon" src="./img/free.gif" alt=""></span>
                        </div>
                        <div class="panel_subtitle"><span class="subtitle_text">全自动Ai写作 免费试用</span></div>

                        <!-- <div class="code_wrap">
                            <img v-if="code_url&&showCodeImg" class="code_img" :src="code_url" alt="">
                            <div class="scan_result" v-if="scanSuccessVisible&&appid=='qywx'">
                                <img class="success_icon" src="./img/success.png" alt="">
                                <div class="success_text">扫码成功</div>
                                <div class="rescan_btn" @click="scanCodeAgain">重新扫码</div>
                            </div>
                            <div class="scan_result" v-else-if="scanSuccessVisible">
                                <img class="success_icon" src="./img/success.png" alt="">
                                <div class="success_text">扫码关注成功</div>
                                <div class="rescan_btn" @click="scanCodeAgain">重新扫码</div>
                            </div>
                            <div class="img_loading"><svg class="text-black" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="2 4" stroke-dashoffset="6" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"><animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite" values="6;0"></animate></path><path stroke-dasharray="30" stroke-dashoffset="30" d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s" values="30;0"></animate></path><path stroke-dasharray="10" stroke-dashoffset="10" d="M12 8v7.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="10;0"></animate></path><path stroke-dasharray="6" stroke-dashoffset="6" d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="6;0"></animate></path></g></svg></div>
                        </div>
                        <div class="tab_pane_text" v-if="appid=='qywx'">微信扫码「添加到通讯录」授权PC端登录</div>
                        <div class="tab_pane_text" v-else>微信扫码“关注公众号”自动登录</div> -->
                        
                        <div class="body_content">
                            <div class="form_content_nav">
                                <div class="nav_item" @click="loginType=1">扫码登录<svg class="nav_icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 12l-4-4m4 4l-4 4m4-4H5m5 9a9 9 0 1 0 0-18"></path></svg></div> 
                                <div class="nav_item" @click="loginType=2">账号登录</div>
                                <div :style="{'left':65+(loginType-1)*130+'px'}" class="tab_bar"></div>
                            </div>
                            <div class="form_content_body">
                                <transition name="left-slide">
                                    <div class="tab_pane" v-if="loginType==1">
                                        <div class="code_wrap">
                                            <img v-if="code_url&&showCodeImg" class="code_img" :src="code_url" alt="">
                                            <div class="scan_result" v-if="scanSuccessVisible&&appid=='qywx'">
                                                <img class="success_icon" src="./img/success.png" alt="">
                                                <div class="success_text">扫码成功</div>
                                                <!-- <div class="success_label">请在企业微信中授权PC端登录</div> -->
                                                <div class="rescan_btn" @click="scanCodeAgain">重新扫码</div>
                                            </div>
                                            <div class="scan_result" v-else-if="scanSuccessVisible">
                                                <img class="success_icon" src="./img/success.png" alt="">
                                                <div class="success_text">扫码关注成功</div>
                                                <!-- <div class="success_label">请在公众号中授权PC端登录</div> -->
                                                <div class="rescan_btn" @click="scanCodeAgain">重新扫码</div>
                                            </div>
                                            <div class="img_loading"><svg class="text-black" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="2 4" stroke-dashoffset="6" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"><animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite" values="6;0"></animate></path><path stroke-dasharray="30" stroke-dashoffset="30" d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s" values="30;0"></animate></path><path stroke-dasharray="10" stroke-dashoffset="10" d="M12 8v7.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="10;0"></animate></path><path stroke-dasharray="6" stroke-dashoffset="6" d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="6;0"></animate></path></g></svg></div>
                                        </div>
                                        <div class="tab_pane_text" v-if="appid=='qywx'">微信扫码「添加到通讯录」授权PC端登录</div>
                                        <div class="tab_pane_text" v-else>微信扫码“关注公众号”自动登录</div>
                                    </div>
                                </transition>
                                <transition name="right-slide">
                                    <div class="tab_pane input_wrap" v-if="loginType==2">
                                        <div class="form_item">
                                            <div class="input_label">账号</div>
                                            <div class="input_wrapper">
                                                <input class="login_input" maxlength="30" v-model="form.username" type="text" placeholder="请输入账号">
                                            </div>
                                        </div>
                                        <div class="form_item mb0">
                                            <div class="input_label">密码</div>
                                            <div class="input_wrapper">
                                                <input class="login_input" maxlength="30" v-model="form.password" type="password" placeholder="请输入密码">
                                            </div>
                                        </div>
                                        <div class="form_feedback">{{ error_tip }}</div>
                                        <button @click="login" class="login_btn">登录</button>
                                    </div>
                                </transition>
                            </div>
                        </div>
                        
                    </div>
                    <div class="agreement"><span @click="agree = !agree" :class="['selct_icon',{'selected':agree}]"></span>同意并阅读 <a href="http://help.xiutanshu.com/help/agree.html">《首选AI网络服务协议》</a> 和 <a href="http://help.xiutanshu.com/help/agree.html">《首选AI用户隐私条款》</a></div>
                </div>
            </div>
        </popup>
	</div>
</template>
<script type="text/javascript">
    import popup from "COMPONENTS/Popup.vue"
	export default{
        components:{popup},
		data () {
			return{
                loginType:1,
                code_url:"",
                img_url:"",
                str_uuid:"",
                timer:null,
                showCodeImg:false,
                agree:true,
                from:1, //1-首页  2-home页
                scanSuccessVisible:false,
                form:{
                    username:"",
                    password:""
                },
                appid:"",
                error_tip:"",
                is_auth_wxa:0,
                isShow:false
			}
		},
        computed:{
           
        },
        created() {
            this.appid = APP_ID
        },
        methods:{
            show(from){
                if(this.isShow) return;
                this.isShow = true;
                let bd_vid = localStorage.getItem("bd_vid")||"";
                let qhclickid = localStorage.getItem("qhclickid")||"";
                let sourceid = localStorage.getItem("sourceid")||"";
                let href = location.href
                let ad_account_id =  localStorage.getItem("ad_account_id")||0;
                let site_id = localStorage.getItem("site_id")||0;
                let timestamp = localStorage.getItem("timestamp")||0;
                if (href.indexOf(MAIN_URLROOT) <= -1) {
                    ad_account_id = ad_account_id || AD_AID
                }
                let keyword = localStorage.getItem("keyword")||"";

                this.from = from||1;
                this.$refs.popup.show();
                let params = {ad_account_id:ad_account_id, site_id:site_id, keyword:keyword, bd_vid:bd_vid, qhclickid:qhclickid, sourceid:sourceid, timestamp:timestamp, source:SiteSource}
                this.$http.get("/front/wx/imagecode/?authorizer_appid="+APP_ID, {params:params}).then((res)=>{
                    this.code_url = res.data.res_img;
                    this.str_uuid = res.data.str_uuid;
                    this.img_url = res.data.img_url;
                    let timer = setTimeout(()=>{
                        this.showCodeImg = true;
                        clearTimeout(timer);
                    },400)
                    this.getLoginInfo();
                })
            },
            closePanel(){
                this.$refs.popup.close();
                this.popClose();
            },
            scanCodeAgain(){
                clearInterval(this.timer);
                this.scanSuccessVisible=false
                this.show(this.from)

            },
            getLoginInfo(){
                this.timer = setInterval(()=>{
                    let bd_vid = localStorage.getItem("bd_vid")||"";
                    let qhclickid = localStorage.getItem("qhclickid")||"";
                    let sourceid = localStorage.getItem("sourceid")||"";
                    let href = location.href
                    let ad_account_id = localStorage.getItem("ad_account_id")||0;
                    let site_id = localStorage.getItem("site_id")||0;
                    let timestamp = localStorage.getItem("timestamp")||0;
                    let keyword = localStorage.getItem("keyword")||"";
                    
                    if (href.indexOf(MAIN_URLROOT) <= -1) {
                        ad_account_id = ad_account_id || AD_AID
                    }
                    let params = {site_id:site_id, bd_vid:bd_vid, qhclickid:qhclickid, keyword:keyword, sourceid:sourceid, timestamp:timestamp}
                    this.$http.get("/front/wx/imagecodelogin/?str_uuid="+this.str_uuid+"&ad_account_id="+ ad_account_id, {params:params}).then((res)=>{
                        if(res.data.is_auth_wxa == 0 && res.data.user_id){
                            // 有user_id, 未授权 提示扫码成功，需要授权
                            this.scanSuccessVisible = true;
                        }else if(res.data.is_auth_wxa == 1 && res.data.user_id && res.data.token){
                        // if(res.data.token){
                            localStorage.setItem("token",res.data.token);
                            localStorage.setItem("user_id",res.data.user_id);
                            localStorage.setItem("showNotice", "")
                            this.getProfile();
                            clearInterval(this.timer);
                            this.timer = null
                            if (href.indexOf(MAIN_URLROOT) > -1) {
                                location.replace("/")
                                if(this.from != 1){
                                    this.closePanel();
                                }
                            } else {
                                let input = localStorage.getItem("inputVal")||"";
                                location.href = MAIN_URLROOT +"/?token=" + res.data.token + "&input="+ input +"&adaid="+ AD_AID + "&timestamp="+timestamp
                            }
                        }
                    })
                },3000)
            },
            login(){
                if(!this.form.username){
                    this.error_tip = "请输入账号"
                    return
                }
                if(!this.form.password){
                    this.error_tip = "请输入密码"
                    return
                }
                this.error_tip = "";
                this.$http.post("/front/auth/login/",this.form).then((res)=>{
                    if(res.status==200){
                        localStorage.setItem("token",res.data.token);
                        this.getProfile();
                        location.replace("/");
                        this.closePanel();
                    }else{
                        this.error_tip = res.message
                    }
                }).catch(res=>{
                    this.error_tip = res.result
                })
            },
            popClose(){
                this.showCodeImg = false;
                this.isShow = false;
                if(this.timer) clearInterval(this.timer)
            },
			getProfile(){
                let invite_code = localStorage.getItem("invite_code")||"";
                let team_code = localStorage.getItem("team_code")||"";
				this.$http.get('/front/aixz/profile/',{params:{invite_code:invite_code, team_code:team_code, app_id:APP_ID}}).then(res =>{
					if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
						this.$store.commit("setIsLogin",true);
						localStorage.setItem("invite_code", this.userInfo.invite_code);
					}else{
						this.$toast(res.message)
					}
				})
			},
        },
        beforeDestroy(){
            if(this.timer) clearInterval(this.timer)
        }
	}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .login_panel{
        width: 700px;
        height: 394px;
        overflow: hidden;
        border-radius: 20px;
        display: flex;
        border-radius: 8px;
        background-color: #fff;
        .panel_left{
            width: 280px;
            flex-shrink: 0;
            background-image: url("./img/login.png");
            padding-top: 70px;
            .panel_logo{
                display: flex;
                justify-content: center;
                margin-bottom: 40px;
                img{
                    display: block;
                    height: 32px;
                }
                .logo_icon{
                    margin-right: 8px;
                }
            }
            .ad_item{
                padding-left: 60px;
                padding-right: 24px;
                position: relative;
                line-height: 28px;
                color: #a7adb4;
                margin-bottom: 18px;
                .ad_icon{
                    position: absolute;
                    width: 20px;
                    left: 26px;
                    top: 7px;
                    display: block;
                }
                .yellow_count{
                    padding: 0 10px;
                    color: #ffd500;
                }
            }
        }
        .panel_right{
            flex-grow: 1;
            position: relative;
            .panel_close{
                position: absolute;
                top: 0;
                right: 0;
                cursor: pointer;
                width: 34px;
                height: 34px;
                z-index: 3;
            }
            .panel_body{
                text-align: center;
                position: relative;
                .panel_title{
                    padding-top: 20px;
                    line-height: 42px;
                    font-size: 22px;
                    .title_text{
                        position: relative;
                        .wx_icon{
                            vertical-align: middle;
                            margin-top: -3px;
                            margin-right: 10px;
                        }
                        .free_icon{
                            position: absolute;
                            right: -28px;
                            top: -20px;
                        }
                    }
                }
                .panel_subtitle{
                    font-size: 12px;
                    line-height: 24px;
                    color: #7b7b7b;
                    .subtitle_text{
                        color: #E94F7D;
                        position: relative;
                        &::before,&::after{
                            content: "";
                            display: block;
                            width: 58px;
                            height: 2px;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        &::before{
                            left: -65px;
                            background-image: linear-gradient(to right, #fff ,#dcdcdc);
                        }
                        &::after{
                            right: -65px;
                            background-image: linear-gradient(to right, #dcdcdc ,#fff);
                        }
                    }
                }
                
                .body_content{
                    padding: 0 48px;
                    .form_content_nav{
                        display: flex;
                        justify-content: space-evenly;
                        border-bottom: 1px solid #e5e7eb;
                        position: relative;
                        .nav_item{
                            cursor: pointer;
                            white-space: nowrap;
                            padding: 10px 0;
                            font-size: 14px;
                            line-height: 1.5;
                            position: relative;
                            .nav_icon{
                                position: absolute;
                                right: -12px;
                                top: 9px;
                            }
                        }
                        .tab_bar{
                            width: 64px;
                            bottom: -1px;
                            position: absolute;
                            height: 2px;
                            background-color: #174ae4;
                            transition: left 0.2s;
                        }
                    }
                    .form_content_body{
                        padding: 12px 50px 0 50px;
                        position: relative;
                        height: 214px;
                        overflow: hidden;
                        .tab_pane{
                            .code_wrap{
                                display: block;
                                margin: 0 auto;
                                border: 1px solid #e6e6e6;
                                width: 165px;
                                height: 165px;
                                padding: 9px;
                                position: relative;
                                .code_img{
                                    width: 100%;
                                    height: 100%;
                                    display: block;
                                    position: relative;
                                    z-index: 2;
                                }
                                .scan_result{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    text-align: center;
                                    padding-top: 36px;
                                    background-color: rgba(255,255,255,0.95);
                                    z-index: 3;
                                    .success_icon{
                                        width: 70px;
                                    }
                                    .success_text{
                                        font-size: 18px;
                                        color: #07c160;
                                        line-height: 36px;
                                        padding-top: 10px;
                                    }
                                    .success_label{
                                        font-size: 15px;
                                        line-height: 35px;
                                    }
                                    .rescan_btn{
                                        display: inline-block;
                                        font-size: 14px;
                                        line-height: 34px;
                                        color: #576b95;
                                        cursor: pointer;
                                    }
                                }
                                .img_loading{
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    .text-black{
                                        color: #000;
                                        display: block;
                                    }
                                }
                            }
                            .tab_pane_text{
                                font-size: 12px;
                                padding-top: 4px;
                                line-height: 32px;
                            }
                            &.input_wrap{
                                .form_item{
                                    padding-bottom: 8px;
                                    &.mb0{
                                        padding-bottom: 0px;
                                    }
                                    .input_label{
                                        line-height: 27px;
                                        font-size: 13px;
                                        padding: 0 0 4px 2px;
                                        color: #444;
                                        text-align: left;
                                    }
                                    .input_wrapper{
                                        position: relative;
                                        .login_input{
                                            width: 100%;
                                            height: 32px;
                                            border-radius: 3px;
                                            font-size: 12px;
                                            border: 1px solid #e5e7eb;
                                            padding: 0 12px;
                                            background-color: transparent;
                                        }
                                        .code_btn{
                                            position: absolute;
                                            border: none;
                                            background-color: transparent;
                                            color: #174AE4;
                                            font-size: 12px;
                                            padding-left: 0.75rem;
                                            border-left: 1px solid #e5e7eb;
                                            cursor: pointer;
                                            right: 0.5rem;
                                            top: 50%;
                                            transform: translateY(-50%);
                                            &:disabled{
                                                color: #ccc;
                                                cursor: not-allowed;
                                            }
                                        }
                                    }
                                }
                                .form_feedback{
                                    font-size: 12px;
                                    line-height: 2.5;
                                    text-align: center;
                                    color: #d03050;
                                }
                                .login_btn{
                                    width: 100%;
                                    height: 34px;
                                    font-size: 14px;
                                    border-radius: 3px;
                                    color: #fff;
                                    background-color: #174AE4;
                                    border: none;
                                    transition: width 0.5s;
                                    margin-top: 10px;
                                }
                            }
                        }
                    }
                }
            }
            .agreement{
                padding-top: 10px;
                font-size: 12px;
                color: #999;
                line-height: 32px;
                text-align: center;
                user-select: none;
                .selct_icon{
                    display: inline-block;
                    vertical-align: middle;
                    margin-top: -3px;
                    border: 1px solid #07c160;
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                    border-radius: 2px;
                    cursor: pointer;
                    &.selected{
                        background-size: 100% 100%;
                        background-image: url("./img/select.png");
                        border: none;
                    }
                }
                a{
                    color: #5f625f;
                }
            }
        }
    }
    .left-slide-enter, .left-slide-leave-to {
        opacity: 0;
        transform: translateX(-30px);
    }
    .left-slide-enter-active,.left-slide-leave-active {
        transition: all 0.2s;
    }
    .right-slide-enter, .right-slide-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
    .right-slide-enter-active,.right-slide-leave-active {
        transition: all 0.2s;
    }
</style>